import { searchFinancialPressRelease as hubFinancialPressReleaseMapper } from '../helpers/filters/financial-press-release';
import { search } from './search';

export const FILTER_HUB_FINANCIAL_PRESS_RELEASE_KEY =
  'financial-press-release-filter';
export const searchFinancialPressRelease = search(
  hubFinancialPressReleaseMapper
);
